<ng-template #expandedPerformer let-expandable="expandable" let-performer="performer">
  <div class="performer_container" [ngClass]="{open: expanded[performer.id], short: !!narrowPerformersHeading }">
    <div class="performer" [ngClass]="{can_expand: expandable}">
      <div class="head" (click)="!expandable ? null : expand($event, performer.id)">
        <ng-container *ngIf="!narrowPerformersHeading">
          <div *ngIf="!performer.photoUrl && !performer.photoHidden" class="account_circle">
            <div class="performer-initials">{{ performer.name | initials }} </div>
            
          </div>
          <div class="shoulders">
            <div *ngIf="performer.photoUrl" class="head_shot">
              <div class="image" [ngStyle]="{'background-image':'url('+performer.photoUrl+')'}"></div>
            </div>
          </div>    
          <div class="details">
            <div class="name">{{ performer.name }}</div>
            <div class="info" *ngIf="performer.line1">{{ performer.line1 }}</div>
            <div class="info" *ngIf="performer.line2">{{ performer.line2 }}</div>
            <menu-hover-button *ngIf="performerRoles && performerRoleIds && performerRoles[performerRoleIds[performer.id] || ''] as role"
              [mobileText]="true"
              [readOnly]="true"
              [hoverText]="'Performer role'" 
              [text]="role.name || 'Unnamed Role'"
              [tooltipLeft]="true">
            </menu-hover-button>
            <labels-view class="performer-labels" *ngIf="labelMap && performer.labels?.length && !performer.hideLabels" [labelMap]="labelMap" [labels]="performer.labels"></labels-view>
          </div>
        </ng-container> 
        <div class="condensed-details" *ngIf="!!narrowPerformersHeading">
          <div class="name">{{ performer.name }}</div>
          <div class="info" *ngIf="performer.line1">, {{ performer.line1 }}</div>
          <div class="info" *ngIf="performer.line2">, {{ performer.line2 }}</div>
          <menu-hover-button *ngIf="performerRoles && performerRoleIds && performerRoles[performerRoleIds[performer.id] || ''] as role"
            [mobileText]="true"
            [readOnly]="true"
            [hoverText]="'Performer role'" 
            [text]="role.name || 'Unnamed Role'"
            [tooltipLeft]="true">
          </menu-hover-button>
          <labels-view class="performer-labels" *ngIf="labelMap && performer.labels?.length && !performer.hideLabels" [labelMap]="labelMap" [labels]="performer.labels"></labels-view>
        </div>
        <div style="flex:1;"></div>
        <div class="expand_arrow_container" *ngIf="expandable">
          <expand-icon [expanded]="expanded[performer.id]"></expand-icon>
        </div>
      </div>
      <div class="body" [@drop]="allExpanded || expanded[performer.id] ? 'expand' : 'collapse'">
        <div class="short-head-holder" *ngIf="!!narrowPerformersHeading">
          <div *ngIf="!performer.photoUrl && !performer.photoHidden" class="account_circle">
            <div class="performer-initials">{{ performer.name | initials }} </div>
          </div>
          <div class="shoulders">
            <div *ngIf="performer.photoUrl" class="head_shot">
              <div class="image" [ngStyle]="{'background-image':'url('+performer.photoUrl+')'}"></div>
            </div>
          </div> 
        </div>
        <social-links *ngIf="performer.social && performer.social.length" [socialLinks]="performer.social"></social-links>
<!--         <div  class="social_links">
          <div class="social" *ngFor="let social of performer.social">
            <icon (click)="helpers.goToUrl($event, social.url)" [class]="'social_' + social.type.toLowerCase()" [icon]="'SOCIAL_' + social.type"></icon>
          </div>
        </div> -->
        <div *ngIf="performer.bio" class="bio" [innerHTML]="helpers.strWithBreak(performer.bio)"></div>
        <div *ngIf="performer.logoUrl" class="performer-logo" [style]="'background-image: url('+performer.logoUrl+');'"></div>
      </div>
    </div>
  </div>
</ng-template>

<div class="performers" *ngIf="!hide && !condensedPerformers">
  <h5 class="performer-title" *ngIf="!hidePerformersHeading">PERFORMERS</h5>
  <ng-container *ngFor="let performerId of performerIds">
    <ng-container *ngIf="performers[performerId] as performer" [ngTemplateOutlet]="expandedPerformer" [ngTemplateOutletContext]="{performer: performer, expandable: !!performer.bio || !!performer.social?.length || !!performer.logoUrl}"></ng-container>
  </ng-container>
</div>
<div class="condensed-performers" *ngIf="!hide && condensedPerformers">
  <h5 class="performer-title" *ngIf="!hidePerformersHeading">PERFORMERS</h5>
  <ng-container *ngFor="let performerId of performerIds">
    <div *ngIf="performers[performerId] as performer" class="performer">
      <span class="performer-name">{{ performer.name || '' }}</span>{{ performer.name && (performer.line1 || performer.line2 ) ? ', ' : ''}}{{ performer.line1 || ''}}{{ performer.line1 && performer.line2 ? ', ' : ''}}{{ performer.line2 || ''}}
      <menu-hover-button *ngIf="performerRoles && performerRoleIds && performerRoles[performerRoleIds[performer.id || ''] || ''] as role"
        [mobileText]="true"
        [readOnly]="true"
        [hoverText]="'Performer role'" 
        [text]="role.name || 'Unnamed Role'"
        [tooltipLeft]="true">
      </menu-hover-button>
    </div>
  </ng-container>
</div>